import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(quantityOrderedStyles, {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-top: 0px;
                flex-direction: row;
                align-items: center;
                color: ${COLORS.lightBlack};
                label {
                    text-align: center;
                    padding: 9px;
                    width: 50%;
                    border-radius: 0;
                    background-color: #e1e7ed;
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 13px !important;
                        padding: 11px 10px 10px;
                    }
                    @media (max-width: 991px) {
                        border-radius: 8px 0 0 8px;
                    }
                }
                & > div {
                    margin-top: 0 !important;
                    > input {
                        border: 0 none !important;
                        @media (max-width: 991px) {
                            border-radius: 0 8px 8px 0 !important;
                        }
                    }
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 13px !important;
                    }
                }
            `,
        },
    },
});
